import React, { useContext } from 'react';
import { SocketIOProvider } from 'use-socketio';
import { useSocket } from 'use-socketio';

import { ctx } from 'store';

const API_URL = process.env.REACT_APP_API_BASE;

const RealTimeConnect: React.FC = ({ children }) => {
  const {
    data: { data },
  } = useContext(ctx.store);

  const actions = useContext(ctx.actions);

  useSocket('data', (newData: any) => {
    actions.data.setData([...data, ...newData]);
  });

  return <>{children}</>;
};

const RealTime: React.FC = ({ children }) => {
  const {
    teams: { currentTeam },
    auth: { token },
  } = useContext(ctx.store);
  return (
    // TODO: Send the token in a different way
    <SocketIOProvider
      url={`${API_URL}/?token=${token}&team=${
        currentTeam.teamId ? currentTeam.teamId : currentTeam.tenantId
      }&platform=${currentTeam.teamId ? 'slack' : 'microsoft'}`}
    >
      <RealTimeConnect>{children}</RealTimeConnect>
    </SocketIOProvider>
  );
};

export { RealTime };
